import {useLocation} from 'react-router-dom';
import {useCallback, useEffect, useState} from 'react';
import {FollowerCount, Platform, Platforms, SocialPostType, SocialPostTypes} from '../types/Types';

interface Props {
	socialPostTypes: SocialPostType[];
	charge: number | undefined;
}

const useFollowers = ({socialPostTypes, charge}: Props) => {
	const [followers, setFollowers] = useState<FollowerCount | undefined>();
	const {state} = useLocation();

	const updateFollowers = useCallback(
		(platform: Platform, val: number | undefined) => {
			setFollowers((current) => {
				const newCurrent = !current ? ({} as FollowerCount) : {...current};
				newCurrent[platform] = val;
				return newCurrent;
			});
		},
		[setFollowers],
	);

	const removeFollowers = useCallback(
		(platform: Platform) => {
			setFollowers((current) => {
				const newCurrent = !current ? ({} as FollowerCount) : {...current};
				if (platform in newCurrent) delete newCurrent[platform];
				return newCurrent;
			});
		},
		[setFollowers],
	);

	const isEditing = useCallback(() => state?.option === 'edit' || state?.option === 'copy', [state]);

	useEffect(() => {
		const suggestedFollowerCount = charge ? charge * 2 : 1;
		if (socialPostTypes?.includes(SocialPostTypes.tiktok)) {
			updateFollowers(
				Platforms.tiktok,
				isEditing() && state?.minTiktokCount > 0 ? state?.minTiktokCount : suggestedFollowerCount,
			);
		} else {
			removeFollowers(Platforms.tiktok);
		}

		if (socialPostTypes?.includes(SocialPostTypes.igPost) || socialPostTypes?.includes(SocialPostTypes.igStory)) {
			updateFollowers(
				Platforms.ig,
				isEditing() && state?.minInstagramCount > 0 ? state?.minInstagramCount : suggestedFollowerCount,
			);
		} else {
			removeFollowers(Platforms.ig);
		}
	}, [socialPostTypes, updateFollowers, removeFollowers, charge, state, isEditing]);

	return {followers, updateFollowers};
};

export default useFollowers;
